import { useEffect, useState } from "react";
import { Loader2, ScrollText } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";
import { Textarea } from "@/components/ui/textarea";

export function LegalAdmin() {
  const [s, setS] = useState(null);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/admin/legal/stats").then(({ data }) => { setS(data); setText((data.changes || []).join("\n")); }).catch((e) => toast.error(formatErr(e)));
  useEffect(() => { load(); }, []);
  const changes = text.split("\n").map((l) => l.trim()).filter(Boolean);
  const bump = async () => {
    if (!window.confirm("Alle Mitglieder müssen den Regeln danach erneut zustimmen, bevor sie die App weiter nutzen können. Fortfahren?")) return;
    setBusy(true);
    try { await api.post("/admin/legal/bump", { changes }); toast.success("Zustimmung wird bei allen neu angefragt"); load(); }
    catch (e) { toast.error(formatErr(e)); } finally { setBusy(false); }
  };
  return (
    <div className="rounded-3xl bg-white border border-pink-100 p-5 space-y-4" data-testid="legal-admin">
      <h2 className="text-lg font-extrabold flex items-center gap-2"><ScrollText className="w-5 h-5 text-rose-500" /> Regeln & Zustimmung</h2>
      <p className="text-sm text-slate-500">Hast du Nutzungsbedingungen, AGB oder Datenschutz geändert? Schreib unten kurz auf, was neu ist (eine Zeile = ein Stichpunkt) und tippe auf den Knopf. Alle Mitglieder sehen dann beim nächsten Öffnen einmalig ein Fenster mit diesen Stichpunkten, das sich erst mit „Ich stimme zu“ schließt.</p>
      {s ? (
        <div className="rounded-2xl bg-rose-50 p-4 text-sm" data-testid="legal-admin-stats">
          <p>Aktuelle Fassung seit: <b>{new Date(s.version).toLocaleString("de-DE")}</b></p>
          <p>Zugestimmt: <b data-testid="legal-admin-accepted">{s.accepted}</b> von <b>{s.total}</b> Mitgliedern</p>
        </div>
      ) : <Loader2 className="w-5 h-5 animate-spin text-rose-400" />}
      <label className="block space-y-1.5">
        <span className="text-sm font-bold">Was hat sich geändert? <span className="font-normal text-slate-400">({changes.length}/12 Stichpunkte)</span></span>
        <Textarea value={text} onChange={(e) => setText(e.target.value)} rows={7} placeholder={"z. B. Neue Regeln für Vibes\nKonto löschen mit 14 Tagen Bedenkzeit"} data-testid="legal-admin-changes" className="rounded-2xl" />
      </label>
      <button onClick={bump} disabled={busy || changes.length > 12} data-testid="legal-admin-bump" className="w-full h-12 rounded-full pink-gradient text-white font-bold inline-flex items-center justify-center gap-2 disabled:opacity-50">
        {busy && <Loader2 className="w-4 h-4 animate-spin" />} Regeln geändert – Zustimmung neu anfragen
      </button>
    </div>
  );
}
